import { useState } from 'react';
import type { CheckResult } from '../api';

export function CheckCard({ title, result }: { title: string; result: CheckResult | undefined }) {
  const [showRaw, setShowRaw] = useState(false);
  if (!result) {
    return (
      <div className="card">
        <h2>
          {title} <span className="badge unknown">not checked</span>
        </h2>
      </div>
    );
  }
  return (
    <div className="card">
      <h2>
        {title} <span className={`badge ${result.status}`}>{result.status}</span>
        {typeof result.score === 'number' && <span className="muted" style={{ marginLeft: 'auto' }}>Score {result.score}</span>}
      </h2>
      <p className="muted">{result.summary}</p>
      {result.findings.length > 0 && (
        <ul className="findings">
          {result.findings.map((f, i) => (
            <li key={i} className={f.severity}>
              <strong>{f.message}</strong>
              {f.fix && <div className="fix">Fix: {f.fix}</div>}
            </li>
          ))}
        </ul>
      )}
      {result.recommendation && (
        <div style={{ marginTop: 12, padding: 12, border: '1px solid var(--border)', borderRadius: 4, background: 'rgba(88,166,255,0.06)' }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            Recommended record{' '}
            <span className="badge info" style={{ marginLeft: 6 }}>{result.recommendation.stage}</span>
            {result.recommendation.alreadyStrong && (
              <span className="badge pass" style={{ marginLeft: 6 }}>already strong</span>
            )}
          </div>
          <pre style={{ marginTop: 4 }}>{result.recommendation.recommended}</pre>
          {result.recommendation.rationale.length > 0 && (
            <ul style={{ margin: '6px 0 0 18px', padding: 0, color: 'var(--muted)', fontSize: 13 }}>
              {result.recommendation.rationale.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>
          )}
          <button
            className="secondary"
            style={{ marginTop: 8 }}
            onClick={() => navigator.clipboard.writeText(result.recommendation!.recommended)}
          >
            Copy
          </button>
        </div>
      )}
      {result.raw.length > 0 && (
        <details style={{ marginTop: 12 }} open={showRaw} onToggle={(e) => setShowRaw((e.target as HTMLDetailsElement).open)}>
          <summary>Raw record{result.raw.length > 1 ? `s (${result.raw.length})` : ''}</summary>
          {result.raw.map((r, i) => (
            <pre key={i}>{r}</pre>
          ))}
        </details>
      )}
      {result.parsed != null && (
        <details>
          <summary>Parsed fields</summary>
          <pre>{JSON.stringify(result.parsed, null, 2)}</pre>
        </details>
      )}
    </div>
  );
}
